import React, { useState } from "react";
import styled from "styled-components";

const Root = styled.div((props) => ({
  ".tabs": {
    padding: 5,
    paddingLeft: 2,
    paddingBottom: 0,
    borderRadius: 5,
    backgroundColor: "#444",
    fontSize: 14,
    marginTop: 10,
  },
  ".tab": {
    backgroundColor: "transparent",
    border: 0,
    padding: 10,

    fontSize: 14,
    fontWeight: 500,
    minWidth: 200,
    color: "#fff",
    paddingBottom: 2,
    cursor: "pointer",
  },
  ".active": {
    color: "#fff",
    cursor: "pointer",
    fontSize: 14,
  },
  ".tab-content": {
    borderRadius: 5,
    marginTop: 5,
    padding: 10,
  },
}));

const CustomTabs = ({ tabs, contents }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <Root>
      <div className="tabs">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`tab ${activeTab === index ? "active" : ""}`}
            onClick={() => handleTabClick(index)}
            type="button"
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="tab-content">
        {contents.map(
          (content, index) =>
            activeTab === index && <div key={index}>{content}</div>
        )}
      </div>
    </Root>
  );
};

export default CustomTabs;
